import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Field } from 'redux-form';
import { Utils } from '../../services';
import { sort_layouts_by_localized_name } from '../../services/layoutListSort';
import SelectField from '../SelectField/SelectField';
import MultiSelectField from '../MultiSelectField/MultiSelectField';
import i18n from 'i18next';

import './EmailLayoutsField.scss';

function filter_email_layouts_by_types(layouts, types) {
    if (!Array.isArray(layouts))
        return [];

    if (!Array.isArray(types) || types.length === 0)
        return layouts;

    return layouts.filter(layout => types.includes(layout?.type));
}

const EmailLayoutEditLink = ({ input }) => {
    const { t } = useTranslation();

    if (!input.value)
        return null;

    return (
        <Link
            to={`/email_layouts/edit/${encodeURIComponent(input.value)}`}
            className="EmailLayoutsField-edit-link btn btn-sm btn-link"
            title={t('layouts.references.open_layout')}
        >
            <i className="fa fa-external-link" aria-hidden="true" />
        </Link>
    );
};

const EmailLayoutsField = ({ emailLayouts, types, single, name, placeholder, show_edit_link = true, showType }) => {
    const { t } = useTranslation();
    const default_lang = Utils.default_lang();
    const filtered_layouts = sort_layouts_by_localized_name(
        filter_email_layouts_by_types(emailLayouts || [], types),
        i18n.language,
    );
    const prefixType = showType ?? (Array.isArray(types) && types.length > 1);

    const options = filtered_layouts.map((emailLayout) => {
        const layoutName = emailLayout.name[i18n.language] ?? emailLayout.name[default_lang];
        const typeLabel = emailLayout.type
            ? t(`layouts.type_email_${emailLayout.type}`)
            : null;

        return {
            key: emailLayout._id,
            text: prefixType && typeLabel ? `${typeLabel} — ${layoutName}` : layoutName,
            value: emailLayout._id,
        };
    });

    const selector = (
        single
            ? <SelectField name={name} options={options} placeholder={placeholder} clearable />
            : <MultiSelectField name={name} options={options} />
    );

    if (!show_edit_link)
        return selector;

    return (
        <div className="EmailLayoutsField">
            <div className="EmailLayoutsField-select">
                {selector}
            </div>
            <Field name={name} component={EmailLayoutEditLink} />
        </div>
    );
};

export default EmailLayoutsField;
